<img *ngIf="!hideIcon" class="icon" alt="confirmation type icon" [src]="iconUri" [class.warning]="isWarning">
<div *ngIf="hideIcon" class="img-stand-in"></div>
<h3 class="message" [innerHTML]="message"></h3>
<div *ngIf="innerHtml" [innerHTML]="innerHtml | safeHtmlSanitizer"></div>
<div class="dropdown-container" *ngIf="hideDropdown">
	<select class="dropdown" (change)="onSelectChange($event)">
		<option *ngFor="let option of options" [value]="option">{{option}}</option>
	</select>
	<span class="dropdown-label">回分</span>
</div>

<ng-container *ngIf="isSubscriptionDelay">
	<div class="subscription-delay-fields-container">
		<div class="delay-field">
			<div class="label">{{'medicalRecord.subscription.currentPaymentDateField' | translate}} :</div>
			<div class="value" *ngIf="subscriptionNextPaymentDate">{{subscriptionNextPaymentDate | date: 'y/MM/d'}}</div>
		</div>
		<div class="delay-field">
			<div class="label">{{'medicalRecord.subscription.nextPaymentDateField' | translate}} :</div>
			<form [formGroup]="nextPaymentForm">
				<aga-date-picker id="next-payment-date" 
												type="number" 
												formControlName="selectedNextPaymentDate"
												[minDate]="minSubscriptionDelayDate" 
												[disabledDates]="disabledDatesBeforeCurrentNextPayment"></aga-date-picker>
			</form>
		</div>
		<span class="note">{{'medicalRecord.subscription.nextPaymentNote' | translate}}</span>
	</div>
</ng-container>

<ng-container *ngIf="isRefundSubscriptionOrder">
	<div class="refund-dialog">
		<div class="medicine-list">
			<div class="table-header">
				<th class="medicine-name">{{'refund.medicineName' | translate}}</th>
				<th class="price">{{'refund.price' | translate}}</th>
				<th class="amount">{{'refund.amount' | translate}}</th>
			</div>
			
			<div *ngFor="let medicine of order?.medicines" class="table-row">
				<td class="medicine-name">{{medicine.name}}</td>
				<td class="price">{{medicine.price | currency:'JPY':'symbol'}}</td>
				<td class="amount">{{medicine.quantity}}</td>
			</div>
		</div>
		<div class="refund-amount">
			<div class="label">{{'patientInformation.ordersAndPrescriptionsList.totalRefundAmount' | translate}} </div>
			<div class="value">{{order?.orderTotalCost | currency:'JPY':'symbol'}}</div>
		</div>
	</div>
</ng-container>

<div class="buttons">
	<aga-button *ngIf="!hideLeftButton"
	            id="left-confirmation-button"
	            class="left-confirmation-button"
	            [color]="invertButtonColors ? 'primary' : 'secondary'"
	            (click)="onLeftButtonClick()">{{leftButtonText}}</aga-button>
	<aga-button *ngIf="!hideRightButton"
	            id="right-confirmation-button"
	            class="right-confirmation-button"
							[disabled]="isConfirmButtonDisabled()"
	            [color]="invertButtonColors ? 'secondary': 'primary'"
	            (click)="onRightButtonClick()">{{rightButtonText}}</aga-button>
</div>
